export default __webpack_public_path__ + "static/media/gun-icon.093aa833.svg";